/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export interface InitiateEmailChangeRequestDto {
  newEmail: string;
}

export interface InitiateEmailChangeResponseDto {
  requestId?: string;
  otpSentToEmail?: string;
  success?: boolean;
  message?: string;
}

export interface FinalizeEmailChangeRequestDto {
  requestId: string;
  otp: string;
}

export interface FinalizeEmailChangeResponseDto {
  success?: boolean;
  message?: string;
}

export class EmailChangeService {

    /**
     * @param requestBody
     * @returns InitiateEmailChangeResponseDto OK
     * @throws ApiError
     */
    public static postApiIdentityApiAppEmailChangeInitiateEmailChange(
        requestBody?: InitiateEmailChangeRequestDto
    ): CancelablePromise<InitiateEmailChangeResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/identity/api/app/email-change/initiate-email-change',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns FinalizeEmailChangeResponseDto OK
     * @throws ApiError
     */
    public static postApiIdentityApiAppEmailChangeFinalizeEmailChange(
        requestBody?: FinalizeEmailChangeRequestDto
    ): CancelablePromise<FinalizeEmailChangeResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/identity/api/app/email-change/finalize-email-change',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
